import {
  RECEIVE_CONTEST_ITEMS,
  TOGGLE_ACTIVE_CONTEST_POPUP,
  SET_ACTIVE_CONTEST_POPUP,
  SET_CONTEST_MODE,
  SET_SIGNUP_FLOW,
  SET_CONTEST_STEP,
  TOGGLE_ACTIVE_AUTH_POPUP,
  CONTEST_HAS_SUBMITTED,
  REQUEST_CONTEST_ITEMS,
  CLEAR_CONTEST_SUBMITTED_ERROR,
  RECEIVE_CONTEST_SUBMITTED_ERROR
} from '../constants/actionTypes';
import { fakeContestItems } from '../constants/fakeContestItems';
import api, { apiAuth } from '../api';

export const setContestItems = data => ({
  type: RECEIVE_CONTEST_ITEMS,
  data
});

export const requestContestItems = () => ({
  type: REQUEST_CONTEST_ITEMS
});

export const contestHasSubmitted = hasSubmitted => ({
  type: CONTEST_HAS_SUBMITTED,
  hasSubmitted
});

export const clearSubmissionError = () => ({
  type: CLEAR_CONTEST_SUBMITTED_ERROR
});

export const receiveSubmissionError = submissionError => ({
  type: RECEIVE_CONTEST_SUBMITTED_ERROR,
  submissionError
});

export const toggleActiveContestPopUp = show => ({
  type: TOGGLE_ACTIVE_CONTEST_POPUP,
  show
});

export const toggleActiveAuthPopUp = show => ({
  type: TOGGLE_ACTIVE_AUTH_POPUP,
  show
});

export const setActiveContestPopUp = id => ({
  type: SET_ACTIVE_CONTEST_POPUP,
  id
});

export const setContestMode = status => ({
  type: SET_CONTEST_MODE,
  status
});

export const setSignupFlow = flow => ({
  type: SET_SIGNUP_FLOW,
  flow
});

export const setContestStep = step => ({
  // step = 'voting', 'voted', 'comment', 'done', 'alreadyVoted'
  type: SET_CONTEST_STEP,
  step
});

// Open contest item popup with ID selected
export function showActiveContestPopUp(id, show) {
  document.body.style.overflow = 'hidden';
  return function(dispatch) {
    dispatch(setActiveContestPopUp(id));
    dispatch(toggleActiveContestPopUp(show));
  };
}

// Prod
export function fetchContestItems(background) {
  return function(dispatch) {
    if (!background) {
      dispatch(requestContestItems());
    }
    return apiAuth('/v1/contest/trips')
      .then(response => {
        console.log('signedIn', response.data);
        dispatch(setContestItems(response.data));
      })
      .catch(err => {
        if (err === 'No current user') {
          return api
            .get('/v1/contest/trips')
            .then(response => {
              console.log('guest', response.data);
              dispatch(setContestItems(response.data));
            })
            .catch(err => {
              dispatch(setContestItems(err));
            });
        }
        dispatch(setContestItems(err));
      });
  };
}

// Prod
export function submitContest(data, xcsrfToken) {
  return function(dispatch) {
    return apiAuth('/v1/contest/vote', 'post', xcsrfToken, data)
      .then(response => {
        dispatch(contestHasSubmitted(true));
      })
      .catch(err => {
        dispatch(receiveSubmissionError(err.response.data.message));
      });
  };
}
